import { render } from "./DocumentSkeletonLoader.vue?vue&type=template&id=491f5247&scoped=true"
import script from "./DocumentSkeletonLoader.vue?vue&type=script&lang=js"
export * from "./DocumentSkeletonLoader.vue?vue&type=script&lang=js"

import "./DocumentSkeletonLoader.vue?vue&type=style&index=0&id=491f5247&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-491f5247"]])

export default __exports__